export const PRODUCT_TYPE_CANONICAL_BY_SLUG: Record<string, string> = {
  pallets: "Pallets",
  "gaylord-boxes": "Gaylord Boxes",
  "ibc-totes": "IBC Totes",
  "metal-drums": "Metal Drums",
  "plastic-drums": "Plastic Drums",
  "fiber-drums": "Fiber Drums",
  "wood-crates": "Wood Crates",
  "plastic-pallets": "Plastic Pallets",
  "wooden-spools": "Wooden Spools",
  "plastic-crates": "Plastic Crates",
  "bulk-bags": "Bulk Bags",
  "cardboard-bales": "Cardboard Bales",
  "shipping-boxes": "Shipping Boxes",
  lumber: "Lumber",
  equipment: "Equipment",
  "moving-boxes": "Moving Boxes",
  "wire-baskets": "Wire Baskets",
  "metal-cages": "Metal Cages",
  "plastic-bins": "Plastic Crates",
  "stretch-wrap": "Stretch Wrap",
  strapping: "Strapping",
};

const PRODUCT_NAME_NORMALIZATION: Record<string, string> = {
  pallet: "Pallets",
  pallets: "Pallets",
  "gaylord box": "Gaylord Boxes",
  "gaylord boxes": "Gaylord Boxes",
  gaylord: "Gaylord Boxes",
  "ibc tote": "IBC Totes",
  "ibc totes": "IBC Totes",
  ibc: "IBC Totes",
  "metal drum": "Metal Drums",
  "metal drums": "Metal Drums",
  "plastic drum": "Plastic Drums",
  "plastic drums": "Plastic Drums",
  "wood crate": "Wood Crates",
  "wood crates": "Wood Crates",
  "wooden crate": "Wood Crates",
  "wooden crates": "Wood Crates",
  "plastic pallet": "Plastic Pallets",
  "plastic pallets": "Plastic Pallets",
  "wooden spool": "Wooden Spools",
  "wooden spools": "Wooden Spools",
  "bulk bag": "Bulk Bags",
  "bulk bags": "Bulk Bags",
  "shipping box": "Shipping Boxes",
  "shipping boxes": "Shipping Boxes",
  "moving box": "Moving Boxes",
  "moving boxes": "Moving Boxes",
  "plastic bin": "Plastic Crates",
  "plastic bins": "Plastic Crates",
};

export function canonicalProductType(
  slug: string | undefined | null,
  name: string | undefined | null,
): string | undefined {
  if (slug) {
    const bySlug = PRODUCT_TYPE_CANONICAL_BY_SLUG[slug.trim().toLowerCase()];
    if (bySlug) return bySlug;
  }
  if (name) {
    const trimmed = name.trim();
    if (!trimmed) return undefined;
    const byName = PRODUCT_NAME_NORMALIZATION[trimmed.toLowerCase()];
    if (byName) return byName;
    return trimmed;
  }
  return undefined;
}
